import { EARNINGS_CALCULATOR_CONSTANTS } from "./EarningsCalculator.constants";

export const formatIndianCurrency = (amount) => {
  if (amount === undefined || amount === null) return "0";
  return new Intl.NumberFormat("en-IN").format(amount);
};

export const calculateCommissionPerReferral = (annualPrice, commissionRate) => {
  const { PERCENTAGE_DIVISOR } = EARNINGS_CALCULATOR_CONSTANTS;
  return (annualPrice * commissionRate) / PERCENTAGE_DIVISOR;
};

export const calculateTotalEarnings = (
  referralCount,
  annualPrice,
  commissionRate
) => {
  const perReferral = calculateCommissionPerReferral(
    annualPrice,
    commissionRate
  );
  return referralCount * perReferral;
};
